// Types
import { Location } from '../../clients/BackendAdminClient/project-address'

/**
 * @typedef ProjectTypeOption
 * @type {Object}
 * @property {String} name  : Type name
 * @property {String} value : Type value
 */

/** @type {Array<ProjectTypeOption>} */
export const category = [
  { name: 'แนวราบ', value: 'NSL' },
  { name: 'แนวสูง', value: 'NSH' },
]

/** @type {Location} */
export const location = {
  zipCode       : null,
  tumbonCode    : null,
  tumbonPrefix  : null,
  tumbonName    : null,
  amphurPrefix  : null,
  amphurCode    : null,
  amphurName    : null,
  provinceName  : null,
  provinceCode  : null
}


// WEBPACK FOOTER //
// ./src/features/nonsc/common.js